<template>
  <div>
    <v-container class="content-wrapper" fluid id="my-orders-tab">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Orders
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" md="6" class="justify-center d-flex">
          <v-btn-toggle v-model="toggleOrder" rounded mandatory>
            <v-btn value="equipment" class="btn-selected">
              Equipment
            </v-btn>
            <v-btn value="services" class="btn-selected">
              Services
            </v-btn>
            <v-btn value="patents" class="btn-selected">
              Patents
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Equipment Orders Provider -->
      <v-row
        justify="center"
        align="center"
        v-if="$store.getters.roles === 'provider' && toggleOrder === 'equipment'"
      >
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <MyOrdersProvider :search="search" :search-attributes="['title']"></MyOrdersProvider>
          </v-card>
        </v-col>
      </v-row>

      <!-- Equipment Orders Researcher -->
      <v-row
        justify="center"
        align="center"
        v-if="$store.getters.roles === 'researcher' && toggleOrder === 'equipment'"
      >
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <MyOrdersResearcher
              :search="search"
              :search-attributes="['title']"
            ></MyOrdersResearcher>
          </v-card>
        </v-col>
      </v-row>

      <!-- Equipment Orders Hosting Representative -->
      <v-row
        justify="center"
        align="center"
        v-if="$store.getters.roles === 'institution-representative' && toggleOrder === 'equipment'"
      >
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <MyOrdersHostingRepresentative
              :search="search"
              :search-attributes="['title']"
            ></MyOrdersHostingRepresentative>
          </v-card>
        </v-col>
      </v-row>

      <!-- Patent Orders Provider -->
      <v-row
        justify="center"
        align="center"
        v-if="$store.getters.roles === 'provider' && toggleOrder === 'patents'"
      >
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <MyOrdersPatentProvider
              :search="search"
              :search-attributes="['title']"
            ></MyOrdersPatentProvider>
          </v-card>
        </v-col>
      </v-row>

      <!-- Patent Orders Researcher -->
      <v-row
        justify="center"
        align="center"
        v-if="$store.getters.roles === 'researcher' && toggleOrder === 'patents'"
      >
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <MyOrdersPatentResearcher
              :search="search"
              :search-attributes="['title']"
            ></MyOrdersPatentResearcher>
          </v-card>
        </v-col>
      </v-row>

      <!-- Patent Orders Hosting Representative -->
      <v-row
        justify="center"
        align="center"
        v-if="$store.getters.roles === 'institution-representative' && toggleOrder === 'patents'"
      >
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <MyOrdersPatentHostingRepresentative
              :search="search"
              :search-attributes="['title']"
            ></MyOrdersPatentHostingRepresentative>
          </v-card>
        </v-col>
      </v-row>

      <!-- Services Orders Provider -->
      <v-row
        justify="center"
        align="center"
        v-if="$store.getters.roles === 'provider' && toggleOrder === 'services'"
      >
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <MyOrdersServicesProvider
              :search="search"
              :search-attributes="['title']"
            ></MyOrdersServicesProvider>
          </v-card>
        </v-col>
      </v-row>

      <!-- Services Orders Researhcer  -->
      <v-row
        justify="center"
        align="center"
        v-if="$store.getters.roles === 'researcher' && toggleOrder === 'services'"
      >
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <MyOrdersServicesResearcher
              :search="search"
              :search-attributes="['title']"
            ></MyOrdersServicesResearcher>
          </v-card>
        </v-col>
      </v-row>

      <!-- Services Orders Hosting Representative -->
      <v-row
        justify="center"
        align="center"
        v-if="$store.getters.roles === 'institution-representative' && toggleOrder === 'services'"
      >
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <MyOrdersServicesHostingRepresentative
              :search="search"
              :search-attributes="['title']"
            ></MyOrdersServicesHostingRepresentative>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MyOrdersProvider from './MyOrdersProvider.vue';
import MyOrdersResearcher from './MyOrdersResearcher.vue';
import MyOrdersServicesProvider from './MyOrdersServicesProvider.vue';
import MyOrdersServicesResearcher from './MyOrdersServicesResearcher.vue';
import MyOrdersHostingRepresentative from './MyOrdersHostingRepresentative.vue';
import MyOrdersServicesHostingRepresentative from './MyOrdersServicesHostingRepresentative.vue';
import MyOrdersPatentProvider from './MyOrdersPatentProvider.vue';
import MyOrdersPatentResearcher from './MyOrdersPatentResearcher.vue';
import MyOrdersPatentHostingRepresentative from './MyOrdersPatentHostingRepresentative.vue';

export default {
  name: 'MyOrders',
  components: {
    MyOrdersProvider,
    MyOrdersResearcher,
    MyOrdersServicesProvider,
    MyOrdersServicesResearcher,
    MyOrdersHostingRepresentative,
    MyOrdersServicesHostingRepresentative,
    MyOrdersPatentProvider,
    MyOrdersPatentResearcher,
    MyOrdersPatentHostingRepresentative,
  },
  data: () => ({
    toggleOrder: 'Equipment',
    search: {},
  }),
  watch: {
    '$route.query.toggleOrder'(newValue) {
      if (newValue === 'services') {
        this.toggleOrder = newValue;
      }
    },
  },
  mounted() {
    if (this.$route.query.toggleOrder) {
      this.toggleOrder = this.$route.query.toggleOrder;
    }
  },
};
</script>

<style scoped>
.btn-selected {
  font-weight: bold;
}
</style>
